import _ from 'lodash';
import {
  StrapiResponse, StrapiResponseFindMany,
} from '../types/core';
import { MyOrdersResponse } from '../types/myOrders';
import { OrderRequest, OrderResponse, OrderResponseFull } from '../types/order';
import api from './api';

interface PaginationProps {
  page: number,
  pageSize: number,
  sort?: string,
  searchQuery?: string,
  status?: string,
}

export default {
  async getList({
    page, pageSize, sort, searchQuery, status,
  }: PaginationProps): Promise<StrapiResponseFindMany<MyOrdersResponse>> {
    return (await api.get('/orders/own', {
      params: _.omitBy({
        populate: 'customer',
        'pagination[page]': page,
        'pagination[pageSize]': pageSize,
        'filters[status][$eq]': status,
        'filters[$or][0][customer][user][name][$containsi]': searchQuery,
        'filters[$or][1][customer][user][cpf][$containsi]': searchQuery,
        'filters[$or][2][customer][user][phone][$containsi]': searchQuery,
        'filters[$or][3][description][$containsi]': searchQuery,
      }, (v) => !v),
    }))?.data;
  },

  async getOne(id: number): Promise<StrapiResponse<OrderResponseFull, any>> {
    return (await api.get(`/orders/own/${id}`, {
      params: {
        'populate[customer][populate]': 'user,address,customerReview',
        'populate[orderBillPayment][populate]': '',
        'populate[orderCreditCard][populate]': '',
        'populate[orderReview][populate]': 'operator',
      },
    }))?.data;
  },

};
